module.exports = __webpack_public_path__ + "img/artificial-intelligence.a90c1f96.png";